export default () => ({
  displayedMessages: []
})
